import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./projects.css";

function Projects() {
  const ref = useScrollReveal();

  const projects = [
    {
      title: "Winnership",
      description: "A demo app connecting college athletes with brands to simplify NIL deals. Making it easier for athletes to get sponsored and for brands to find the right talent.",
      tech: ["React", "TypeScript", "Tailwind CSS", "Vite"],
      link: "https://winnership.beauxdolf.com",
      github: "https://github.com/Beaux779/WinnerShip",
    },
    {
      title: "Rubenslist",
      description: 'Rubenslist is a self-service workflow platform for contractors and blue-collar workers. Think Uber for odd jobs. Built with Java and SQL, the platform includes secure authentication, job posting and acceptance, integrated payments, location services, user profiles, and a review system for both workers and customers.',
      tech: ["JavaScript", "SQL", "TailwindCSS", "NPM"],
      link:"https://rubenslist.com",
      github: "https://github.com/Beaux779",
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">02</span>
          <h2 className="section-title">Projects</h2>
        </div>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div className="project-card" key={index}>
              <span className="project-index font-mono">0{index + 1}</span>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              {project.tech.length > 0 && (
                <div className="project-tech">
                  {project.tech.map((tech, i) => (
                    <span key={i} className="tech-tag font-mono">{tech}</span>
                  ))}
                </div>
              )}
              {!project.comingSoon && (
                <>
                  <a href={project.link} className="project-link font-mono" target="_blank" rel="noopener noreferrer">
                    View Project <span className="arrow">→</span>
                  </a>
                  {project.github && (
                    <a href={project.github} className="project-link font-mono" target="_blank" rel="noopener noreferrer">
                      GitHub <span className="arrow">→</span>
                    </a>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
